import axios from "axios";

export const parseApi = (response) => {
  const raw = response?.data;

  if (raw?.body == null) return raw;

  if (typeof raw.body === "string") {
    try {
      return JSON.parse(raw.body);
    } catch (e) {
      console.error("❌ parseApi: body no es JSON válido:", raw.body);
      return raw;
    }
  }

  return raw.body;
};

export const postDashboard = async ({
  endpoint,
  idEquipo,
  fechaInicio,
  fechaFinal,
}) => {
  const token =
    localStorage.getItem("emsToken") ||
    localStorage.getItem("token") ||
    localStorage.getItem("userToken") ||
    "";

  if (!token) {
    throw new Error("No hay sesión activa. Vuelve a iniciar sesión.");
  }

  const res = await axios.post(
    endpoint,
    {
      idEquipo,
      fechaInicio,
      fechaFinal,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  const parsed = parseApi(res);
  if (!parsed?.success) throw new Error(parsed?.message || "Error en API");

  const data = parsed.data;
  if (!Array.isArray(data)) throw new Error("Datos no son array");

  return data;
};